var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-dialog',{attrs:{"width":"280px","confirm-button-text":_vm.$t('Understood')},model:{value:(_vm.remarkPopupStatus),callback:function ($$v) {_vm.remarkPopupStatus=$$v},expression:"remarkPopupStatus"}},[_c('div',{staticClass:"remark-popup-content"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('longPressTip')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }